import { render, staticRenderFns } from "./ListImageGroups.vue?vue&type=template&id=d67a20cc&scoped=true"
import script from "./ListImageGroups.vue?vue&type=script&lang=js"
export * from "./ListImageGroups.vue?vue&type=script&lang=js"
import style0 from "./ListImageGroups.vue?vue&type=style&index=0&id=d67a20cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67a20cc",
  null
  
)

export default component.exports